import {
  Building2, Activity, ShoppingCart, Package, CircleDollarSign,
  ClipboardList, Shield, UserCheck, HardHat,
} from "lucide-react";

export const FIXED_ROLES = [
  { id: "ceo", label: "CEO", desc: "Full system access", user: "u1", icon: Building2, color: "#0ea5e9", home: "dashboard", role: "ceo" },
  { id: "coo", label: "COO", desc: "Operations & project control", user: "u_coo", icon: Activity, color: "#8b5cf6", home: "dashboard", role: "coo" },
  { id: "procurement", label: "Procurement", desc: "PO & deliveries", user: "u3", icon: ShoppingCart, color: "#f59e0b", home: "procurement", role: "procurement" },
  { id: "warehouse", label: "Warehouse", desc: "Stock & transfers", user: "u4", icon: Package, color: "#f97316", home: "warehouse", role: "warehouse" },
  { id: "finance", label: "Finance", desc: "Payments & accounts", user: "u5", icon: CircleDollarSign, color: "#10b981", home: "vendorfinance", role: "finance" },
  { id: "dataentry", label: "Data Entry / Site", desc: "Daily reports", user: "u6", icon: ClipboardList, color: "#06b6d4", home: "daily", role: "dataentry" },
  { id: "hr", label: "HR", desc: "Employee management", user: "u_hr", icon: UserCheck, color: "#ec4899", home: "hr", role: "hr" },
  { id: "admin", label: "Admin", desc: "Settings & reports", user: "u1", icon: Shield, color: "#64748b", home: "dashboard", role: "admin" },
];

export { HardHat };

export const ROLE_PAGES = {
  ceo: null, // all
  coo: null, // all
  admin: null, // all
  pm: ["controlcenter","daily","budgetcost","boqtracking","tasks","variations","procurement","warehouse","equipment","subcontractors","rfi","documents","hse","sitephotos","projectteam","clientfinance","evm","approvals","registers","admin","tenders"],
  supervisor: ["supervisorcc","daily","boqtracking","tasks","variations","warehouse","equipment","subcontractors","rfi","documents","hse","sitephotos","projectteam","evm","approvals","registers"],
  hr: ["hr","employeefinance","registers"],
  procurement: ["procurement","warehouse","registers"],
  warehouse: ["projects","controlcenter","procurement","equipment","warehouse","registers"],
  finance: ["controlcenter","procurement","subcontractors","boqtracking","cashflow","payments","vendorfinance","clientfinance","employeefinance","headoffice","accounts","evm","approvals","registers","tenders"],
  dataentry: ["daily","procurement","warehouse","hse","rfi","documents","sitephotos","registers","admin","tenders"],
};

// Edit permissions: which roles can CREATE/EDIT on each module
export const ROLE_EDITS = {
  dashboard: ["ceo","coo","admin"],
  projects: ["ceo","coo","admin"],
  controlcenter: [],
  supervisorcc: [],
  daily: ["ceo","coo","admin","pm","supervisor","dataentry"],
  budgetcost: ["ceo","coo","admin"],
  tasks: ["ceo","coo","admin"],
  variations: ["ceo","coo","admin","pm","supervisor"],
  procurement: ["ceo","coo","admin","procurement","dataentry"],
  warehouse: ["ceo","coo","admin","warehouse","dataentry","supervisor"],
  equipment: ["ceo","coo","admin","pm","supervisor"],
  projectteam: ["ceo","coo","admin","pm","supervisor"],
  payments: ["ceo","admin","finance"],
  vendorfinance: ["ceo","admin","finance"],
  subcontractors: ["ceo","coo","admin","pm","supervisor","finance"],
  rfi: ["ceo","coo","admin","pm","supervisor","dataentry"],
  documents: ["ceo","coo","admin","pm","supervisor","dataentry"],
  hse: ["ceo","coo","admin","pm","supervisor","dataentry"],
  sitephotos: ["ceo","coo","admin","pm","supervisor","dataentry"],
  cashflow: ["ceo","coo","admin","finance"],
  clientfinance: ["ceo","coo","admin","pm","finance"],
  hr: ["ceo","admin","hr"],
  employeefinance: ["ceo","admin","finance","hr"],
  accounts: ["ceo","admin"],
  headoffice: ["ceo","admin","finance"],
  registers: ["ceo","coo","admin","procurement","finance","hr"],
  boqtracking: [],
  evm: [],
  approvals: ["ceo","coo","admin","pm","supervisor","finance"],
  admin: ["ceo","admin"],
  tenders: ["ceo","coo","dataentry"],
};
